import React from 'react';
import PropTypes from 'prop-types';
import { Link, StaticQuery, graphql, navigate } from 'gatsby';
import { ContainerCss, SearchComp, ModalFind } from './header.css';
import Nav from 'components/nav/nav';
// import SearchNav from 'components/nav/search-nav';
import Title from 'components/title';
import { ModalBody } from 'reactstrap';
import FindATrial from '../search/find-a-trial';
import { IoIosSearch } from 'react-icons/io';

import Img from 'gatsby-image';

//style
import { Row, Col } from 'reactstrap';

class Header extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  disableScrolling(open) {
    setTimeout(() => {
      if (open) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = 'auto';
      }
    }, 100);
  }
  hideSearch = () => {
    this.setState({ collapse: false });
  };

  toggle() {
    // if (typeof document !== 'undefined') {
    //   this.disableScrolling(!this.state.collapse);
    // }

    this.setState(state => ({ collapse: !state.collapse }));
  }

  render() {
    let {
      data,
      logo,
      title,
      mainMenu,
      selectedLanguage,
      searchButton,
    } = this.props;
    return (
      <div>
        <ContainerCss>
          <div className={'header-container'}>
            <Row>
              <Col
                lg={{ order: 2, size: 8 }}
                md={12}
                sm={12}
                className={'col-items menu-icon'}
              >
                {mainMenu && mainMenu.length && (
                  <Nav
                    hideSearch={this.hideSearch}
                    className={'main-menu'}
                    selectedLanguage={selectedLanguage}
                    menuItems={data.pageMetadataJson.pages
                      .filter(page => {
                        return (
                          page.pageLang === selectedLanguage &&
                          mainMenu.includes(page.url)
                        );
                      })
                      .sort((a, b) => {
                        return (
                          mainMenu.indexOf(a.url) - mainMenu.indexOf(b.url)
                        );
                      })}
                  />
                )}
              </Col>
              <Col
                lg={{ order: 1, size: 2 }}
                md={4}
                sm={4}
                className={'col-logo col-logo-tablet'}
              >
                <Link
                  onClick={() => {
                    window.__navigatingToLink = true;
                  }}
                  to="/en"
                >
                  {logo ? (
                    <Img fluid={logo} alt={title} className="header-logo" />
                  ) : (
                    <Title as="h1">
                      {title || data.site.siteMetadata.siteTitle}
                    </Title>
                  )}
                </Link>
              </Col>
              <Col
                lg={{ order: 3, size: 2 }}
                md={4}
                sm={4}
                className={'col-items desktop'}
              >
                <button className={'last'} onClick={this.toggle}>
                  {searchButton}
                </button>
              </Col>
              <Col
                lg={{ order: 3, size: 2 }}
                md={4}
                sm={4}
                className={'col-items tablet'}
              >
                <IoIosSearch onClick={this.toggle} />
              </Col>
            </Row>
          </div>
        </ContainerCss>
        <Row>
          <Col md={12}>
            <ModalFind
              isOpen={this.state.collapse}
              toggle={this.toggle}
            >
              <SearchComp>
                <ModalBody>
                  <FindATrial
                    navigate={navigate}
                    pageContext={{ langKey: selectedLanguage }}
                    pageSearch={
                      typeof window !== 'undefined' &&
                      window.location.href.indexOf('/results') > 1
                        ? () => document.location.reload()
                        : null
                    }
                  />
                </ModalBody>
              </SearchComp>
            </ModalFind>
          </Col>
        </Row>
      </div>
    );
  }
}

const HeaderWithQuery = props => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            siteTitle
            mainMenu
            languages {
              defaultLangKey
              langs
              defaultPageUrl
            }
          }
        }
        pageMetadataJson {
          pages {
            menuTitle
            url
            pageLang
          }
        }
      }
    `}
    render={data => <Header data={data} {...props} />}
  />
);

export default HeaderWithQuery;

Header.propTypes = {
  data: PropTypes.object,
  title: PropTypes.string,
  mainMenu: PropTypes.array.isRequired,
  selectedLanguage: PropTypes.any.isRequired,
  logo: PropTypes.object.isRequired,
  searchButton: PropTypes.string,
};
